<template>
  <customModal :containerxxl="true" @closeModal="closeAssignModal()">
    <template #title>
      SoA Extraction
    </template>
    <template #body>
  <div class="wrapper wrapper-content animated fadeInRight px-0 pt-0">
    <div style="height: 70vh">
      <div class="row h-100">
        <div class="col-lg-4 col-md-12 ibox-content">
          <div>
             <label class="mb-0" for="inputProtocol">{{$t('navigations.browse protocol')}}</label>
            <div class="input-group">            
              <input
                ref="inputProtocol"
                accept=".pdf"
                id="inputProtocol"
                type="file"
                class="form-control my-2 my-lg-0"
                @change="previewFiles($event)"
                :disabled="showLoading"
              />
              <span class="input-group-append">
                <button
                  type="button"
                  class="btn btn-sm btn-primary py-0 position-relative"
                  @click="protocolExport()"
                  :disabled="showLoading"
                >
                  <div
                    class="toc-loader position-absolute"
                    :class="{
                      'opacity-0': showLoading == false,
                      'opacity-1': showLoading == true,
                    }"
                  >
                    <img
                      src="../../assets/img/loading.gif"
                      width="15"
                      class="loading-btn-img"
                      alt="Waiting for login"
                    />
                  </div>
                  <div
                    :class="{
                      'opacity-1': showLoading == false,
                      'opacity-0': showLoading == true,
                    }"
                  >
                    {{ $t("navigations.upload") }}
                  </div>
                </button>
              </span>
             
            </div>
            <div>
            <div class="error-file-block d-flex align-items-center" v-if="showValidation==true">
              <div class="error-icon"> <i class="fa fa-warning"></i></div>            
              <p class="mb-0">{{$t('navigations.please select a file')}}</p>
            </div>
            </div>
           
              <!-- Supported format & download template link -->
            <div class="alert-light d-flex justify-content-between mb-2">
              <small><strong>{{$t('navigations.supported format')}}&nbsp;:</strong> .pdf</small>
            </div>
          </div>
         <div>
          <div class="mb-1">Orientation</div>
            <label>
              <input type="radio" name="orientation" :value="false" v-model="isLandscape">
              Portrait
            </label>
            <label class="ml-2">
              <input type="radio" name="orientation" :value="true" v-model="isLandscape">
              Landscape
            </label>
          </div>
          <div>
            <label class="mb-0" for="soaPages">{{$t('navigations.soa pages')}}</label>
            <div
              v-for="(soaPage, index) in soaPages"
              :key="`soa-page-${index}`"
              class="soa-page-row mb-1"
            >
              <input
                type="text"
                v-model="soaPages[index]"
                class="form-control"
                :id="index === 0 ? 'soaPages' : `soaPages-${index}`"
                @focus="handleSoaPageFocus(index)"
                @input="showSoaPageValidation = false"
              >
              <button
                type="button"
                class="btn btn-sm soa-page-action-btn d-flex align-items-center"
                :class="index === 0 ? 'btn-primary' : 'btn-outline-danger'"
                :aria-label="index === 0 ? 'Add SoA page' : 'Remove SoA page'"
                @click="index === 0 ? addSoaPageField() : removeSoaPageField(index)"
              >
                <i :class="index === 0 ? 'fa fa-plus' : 'fa fa-minus'"></i>
              </button>
            </div>
            <div class="error-file-block d-flex align-items-center mb-1" v-if="showSoaPageValidation==true">
              <div class="error-icon"> <i class="fa fa-warning"></i></div>            
              <p class="mb-0">{{$t('navigations.please add a page number for import')}}</p>
            </div>
            <div class="info-block d-flex align-items-center py-0">
              <div class="info-icon"> <i class="fa fa-info-circle"></i></div>            
              <p class="mb-0">{{$t('navigations.please verify the SoA page numbers before starting the extraction')}}</p>
            </div>
          </div>
          <!-- <div class="mt-3">
            <label class="mb-0" for="soaPages">{{$t('navigations.study name')}}</label>
            <input type="text" v-model="selectedstudy" class="form-control mb-1" id="soaPages">
          </div> -->
         
          <div class="text-end">
            <button class="save_btn mt-2 py-0 px-3 position-relative" @click.prevent="importSoA()"
              :class="{ 'disabled-btn-cls': importLoader == true }">
              <div class="toc-loader position-absolute"
              :class="{ 'opacity-0': importLoader == false, 'opacity-1': importLoader == true }">
              <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
              </div>
              <p class="mb-0" :class="{ 'opacity-1': importLoader == false, 'opacity-0': importLoader == true }">{{
              $t("navigations.import") }}</p>
            </button>
          </div>
           <div v-if="importLoader" class="progress-text">
  Progressing<span class="dots"></span>
</div>
        </div>
        <div class="col-lg-8 col-md-12 ibox-content">
          <div v-if="readyToView==false" class="d-flex justify-content-center align-items-center h-100">
            <div class="text-center">
              <img class="mb-2" src="../../assets/img/EmptyFile.svg" alt="Add a file" width="50"
                 />
              <h4>{{$t('navigations.please upload a protocol to view here')}}</h4>
            </div>
           
          </div>
          <div v-else class="pdfembeded">
            <vue-pdf-embed :source="source" />
          </div>
      </div>
      </div>
    </div>
  </div>
  </template>
  </customModal>
</template>
<script src="./ProtocolExtraction.js"></script>
<style scoped>
.dots::after {
  content: '.....';
  letter-spacing: 3px;
  animation: fadeDots 1.5s infinite;
}
 
@keyframes fadeDots {
  0%   { opacity: 0; }
  20%  { opacity: 0.2; }
  40%  { opacity: 0.4; }
  60%  { opacity: 0.6; }
  80%  { opacity: 0.8; }
  100% { opacity: 1; }
}
.view-link{
   color: hsl(211, 100%, 50%);
}
.info-icon {
  color: hsl(211, 100%, 50%);
  font-size: 1rem;
  margin-right: 10px;
  line-height: 1.2;
}
 
.info-block{
  background: hsl(212, 100%, 97%);
  border: 1px solid #cce5ff;
  border-left: 3px solid #007bff;
  border-radius: 8px;
  padding: 6px 10px;
}
.error-icon {
  color: hsl(4, 100%, 50%);
  font-size: 1rem;
  margin-right: 10px;
  line-height: 1.2;
}
 
.error-file-block{
  background: hsl(0deg 100% 92.06%);
  border: 1px solid #cce5ff;
  border-left: 3px solid #ff1100;
  border-radius: 8px;
  padding: 6px 10px;
}
.opacity-0 {
  opacity: 0;
}
 
.opacity-1 {
  opacity: 1;
}
.import-box {
  border: 2px dashed #618bd7;
  border-radius: 5px;
  padding: 2rem 1rem;
  text-align: center;
  background: #f7fafd;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  position: relative;
}
.import-box--active {
  border-color: #3867d6;
  background: #eaf1ff;
}
.soa-page-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.soa-page-action-btn {
  min-width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: .1rem !important;
}
</style>
